import React from 'react';

export default class Divider extends React.Component {

	render() {
		return (
			<div className="divider">
                <div className="divider-inner">{this.props.label}</div>
            </div>
		)
	}
};


// WEBPACK FOOTER //
// ./src/atoms/Divider.js